import styled from '@emotion/styled';
import { typography } from '@uniquegood/realworld-studio-design';
import { useEffect } from 'react';
import DagooContact from '../../../assets/images/dagoo-contact.svg';
import { PageViewEventName, track } from '@/track';
import { getAccessToken } from '@/auth';

const viewEvent = async () => {
  const accessToken = await getAccessToken();
  track.onPageView({
    pageViewEventName: PageViewEventName.view_plan_enterprise_form_submit_success,
    params: { is_logged_in: accessToken ? 'true' : 'false' }
  });
};
const SubmitSuccess = () => {
  useEffect(() => {
    viewEvent();
  }, []);

  return (
    <Container>
      <ContentWrapper>
        <IconWrapper>
          <img src={DagooContact} alt="submit-success" />
        </IconWrapper>

        <Title>맞춤 상담이 신청됐어요!</Title>

        <Description>
          최대한 빠른 시일내에
          <br />
          입력해주신 이메일로 연락 드릴게요.
        </Description>
      </ContentWrapper>
    </Container>
  );
};

export default SubmitSuccess;

const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100dvh;
  min-width: 100%;
  background: #f5f5f5;
  box-shadow: 0px 0px 30px 0px rgba(0, 0, 0, 0.07);
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 8px 0;
`;

const IconWrapper = styled.div`
  position: relative;
  width: 160px;
  height: 140px;
  flex-shrink: 0;
`;

const Title = styled.h1`
  font-family: 'Pretendard', sans-serif;
  font-size: 28px;
  line-height: 32px;
  font-weight: ${typography.weight.bold};
  color: #1a1a1a;
  text-align: center;
  white-space: nowrap;
  margin: 0;
`;

const Description = styled.div`
  font-family: 'Pretendard', sans-serif;
  font-size: 14px;
  line-height: 20px;
  font-weight: ${typography.weight.regular};
  color: #555555;
  text-align: center;
  white-space: pre-wrap;
`;
